import React, { useContext, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { LayoutContext } from "App/common/hoc/Layout";
// import { SPopupContext } from "App/common/hoc/SlidingPopup";
// import BreadCrumbs from "./BreadCrumb";
// import TransLoader from "App/common/ui/TransLoader";
import { createFolderPop, createFolder, selectCustomPath } from "store/actions";
import { ReactComponent as CloseIcon } from "assets/images/app_svg/close.svg";
import { encodeHandler } from "utils";

function CreateNewFolder(props) {
  const [folderName, setFolderName] = useState("New Folder");
  const [emptyFolderError, setEmptyFolderError] = useState({
    show: false,
    type: "empty"
  });
  const { lState } = useContext(LayoutContext);

  function createFolder(folderName) {
    props.createFolder({
      clientUUID: props.fileRestore.targetMachine.clientUUID,
      path: props.fileRestore.enumFolder.path,
      name: encodeHandler(folderName)
    });
    props.selectCustomPath(encodeHandler(folderName));
  }

  const onChangeHandler = val => {
    if (val.trim()) {
      const characterNotAllowed = /[*":|<>\\?/]/g;
      if (val.length > 50) {
        setEmptyFolderError({ show: true, type: "lengthy" });
      } else {
        if (characterNotAllowed.test(val)) {
          setEmptyFolderError({ show: true, type: "invalid" });
        } else {
          setEmptyFolderError({ show: false, type: "" });
        }
        props.fileRestore.enumFolder.createFolderError = "";
        setFolderName(val);
      }
    } else {
      setFolderName("");

      setEmptyFolderError({ show: true, type: "empty" });
    }
  };

  return (
    <div className="fs_head">
      <div className="fs_head_input ">
        <div className="fsh_box just_flex">
          <input
            type="text"
            className="input_text"
            value={folderName}
            onChange={e => onChangeHandler(e.target.value)}
            onKeyDown={e =>
              e.key === "Enter" &&
              !emptyFolderError.show &&
              createFolder(folderName)
            }
            id="newFolder"
          />
          <span className="close" onClick={() => props.createFolderPop(false)}>
            <CloseIcon />
          </span>{" "}
        </div>
        {(emptyFolderError.show ||
          props.fileRestore.enumFolder.createFolderError) && (
          <span className="error-msg" style={{ display: "block" }}>
            {emptyFolderError.show
              ? emptyFolderError.type === "empty"
                ? "The field cannot be blank"
                : emptyFolderError.type === "lengthy"
                ? "Folder name cannot exceed 50 characters"
                : "A file name can't contain any of following characters."
              : props.fileRestore.enumFolder.createFolderError}
          </span>
        )}
      </div>
      {emptyFolderError.show ? (
        <div className="slider_btn btn_disable">Create</div>
      ) : (
        <div
          className="slider_btn btn_primary"
          onClick={() => createFolder(folderName)}
        >
          Create
        </div>
      )}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    fileRestore: state.fileRestore
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createFolderPop,
      createFolder,
      selectCustomPath
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewFolder);
